import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../config/firebase-config';
import Flashcard from './Flashcard';
import FlashcardsNav from './FlashcardsNav';
import './theme.css';
import './card.css';

const FetchFlashcards = () => {
  const { deckId } = useParams();
  const [deck, setDeck] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    async function fetchDeck() {
      if (!deckId) {
        setError('Deck ID is not defined');
        setLoading(false);
        return;
      }
      try {
        console.log('Fetching deck with ID:', deckId);
        const ref = doc(db, 'flashcardLibrary', deckId);
        const snap = await getDoc(ref);
        if (!snap.exists()) {
          setError('No deck found with this ID.');
          setLoading(false);
          return;
        }
        const data = snap.data();
        console.log('Raw Firebase data:', data);
        console.log('Deck string:', data.deck);
        
        const parsed = JSON.parse(data.deck);
        console.log('Parsed deck:', parsed);
        console.log('Number of cards:', parsed.cards?.length);
        console.log('Cards array:', parsed.cards);
        
        setDeck(parsed);
        setIndex(0);
      } catch (e) {
        console.error('Error parsing deck:', e);
        setError('Failed to fetch deck.');
      } finally {
        setLoading(false);
      }
    }
    fetchDeck();
  }, [deckId]);

  const handleNext = () => {
    console.log('Next clicked, current index:', index, 'total cards:', deck?.cards?.length);
    setIndex((prev) => {
      if (!deck?.cards?.length) return 0;
      const newIndex = (prev + 1) % deck.cards.length;
      console.log('New index:', newIndex);
      return newIndex;
    });
  };

  const handlePrevious = () => {
    console.log('Previous clicked, current index:', index, 'total cards:', deck?.cards?.length);
    setIndex((prev) => {
      if (!deck?.cards?.length) return 0;
      const newIndex = (prev - 1 + deck.cards.length) % deck.cards.length;
      console.log('New index:', newIndex);
      return newIndex;
    });
  };

  if (loading) return (
    <div style={{ minHeight: '100vh', background: 'hsl(var(--background))', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div className="text-foreground">Loading deck…</div>
    </div>
  );
  
  if (error) return (
    <div style={{ minHeight: '100vh', background: 'hsl(var(--background))', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div className="error-message">{error}</div>
    </div>
  );
  
  if (!deck) return (
    <div style={{ minHeight: '100vh', background: 'hsl(var(--background))', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div className="text-foreground">No deck data.</div>
    </div>
  );

  const card = deck.cards?.[index];
  console.log('Current card index:', index, 'card:', card);

  return (
    <div style={{ minHeight: '100vh', background: 'hsl(var(--background))' }}>
      <main className="container" style={{ paddingTop: 32, paddingBottom: 32 }}>
        <FlashcardsNav />
        
        <div className="card" style={{ padding: 24, maxWidth: 800, margin: '0 auto' }}>
          <div className="card-header">
            <div style={{ textAlign: 'center', marginBottom: 16 }}>
              <h1 className="card-title">{deck.title}</h1>
              <p className="card-description">Card {index + 1} of {deck.cards?.length || 0}</p>
            </div>
          </div>

          <div className="card-content">
            {card ? (
              <div style={{ marginBottom: 24 }}>
                <Flashcard
                  flashcard={card}
                  onNext={handleNext}
                  onPrevious={handlePrevious}
                  showNavigation={false}
                />
              </div>
            ) : (
              <div className="text-foreground" style={{ textAlign: 'center', padding: 32 }}>
                No cards found. Total cards: {deck.cards?.length || 0}
              </div>
            )}
          </div>
        </div>
      </main>
    </div>
  );
};

export default FetchFlashcards; 